import { jsx as V } from "react/jsx-runtime";
import { useState as x, useCallback as p, useMemo as h } from "react";
import y from "../../contexts/tab.js";
function k(T) {
  const {
    styleVariant: o = "tab",
    colorVariant: a = o === "tab" ? "text" : "primary",
    disabled: i,
    value: c,
    onChange: u,
    children: g
  } = T, [l, n] = x([]), [d, b] = x(0), f = p((r) => {
    n((t) => t.findIndex((e) => e === r) === -1 ? [...t, r] : t);
  }, [n]), m = p((r) => {
    n((t) => {
      const s = t.findIndex((e) => e === r);
      if (s !== -1) {
        const e = [...t];
        return e.splice(s, 1), e;
      }
      return t;
    });
  }, [n]), C = h(() => ({
    tabs: l,
    colorVariant: a,
    styleVariant: o,
    disabled: !!i,
    activeTab: c,
    setActiveTab: u,
    registerTab: f,
    unregisterTab: m,
    step: d,
    setStep: b
  }), [
    l,
    c,
    u,
    a,
    o,
    i,
    f,
    m,
    d,
    b
  ]);
  return /* @__PURE__ */ V(y.Provider, { value: C, children: g });
}
export {
  k as default
};
